// 德
module.exports = {
  common: {
    edit: "bearbeiten",
    apply: "Anwenden",
    activate: "Aktivierung",
    delete: "löschen",
    cancel: "Stornieren",
    success: "Erfolg",
    fail: "scheitern",
    save: "speichern",
    ensure: "Sicher",
    submit: "einreichen",
    remark: "Anmerkung",
    detail: "Überprüfen",
    action: "arbeiten",
    open: "offen",
    close: "Schließung",
    back: "zurückkehren",
    export: "Export",
    modify: "Überarbeiten",
    layout: "austragen",
    noListData: "Liste enthält keine Daten",
    more: "Einzelheiten",
    add: "Hinzufügen",
    delSuccess: "erfolgreich gelöscht!",
    addFailure: "Hinzufügen fehlgeschlagen!",
    logOut: "Ausloggen",
    delAllInfo: "Möchten Sie den Löschvorgang fortsetzen?",
    saveTip:
      "Sie haben den Inhalt der Seite nicht gespeichert, möchten Sie sie verlassen?",
    tip: "Hinweis",
    yes: "Ja",
    no: "NEIN",
    delTip: "Zum Aktivieren ankreuzen",
    batchDelete: "Stapellöschung",
    search: "Anfragen",
    permission: "Noch keine Berechtigung, bitte gehen Sie zurück",
    reset: "zurücksetzen",
  },
  breadcrumbItem: {
    home: "Konfiguration der Namensliste",
    data: "Allgemeine Gerätekonfigurationspaketierung",
    alarm: "Zonenkonfiguration",
    house: "Hausgrundrisskonfiguration",
    name: "Konfiguration der Namensliste",
  },
  errorRes: {
    res82: "Das System ist ausgelastet, bitte versuchen Sie es später erneut",
  },
  openConfig: {
    title: "Allgemeine Gerätekonfiguration",
    version: "Protokollversion",
    versionTip: "Bitte wählen Sie eine Protokollversion aus",
    checkVersion:
      "Die Protokollversion darf nicht leer sein, bitte erneut wählen",
    signType: "Typ des Signaturalgorithmus",
    checkSignType:
      "Typ des Signaturalgorithmus darf nicht leer sein, bitte erneut wählen",
    fileLabel: "Dokument auswählen",
    addFile: "Dateien hinzufügen",
    fileName: "Dateinamen",
    zipType: "Kompressionsverfahren",
    noZip: "keine Komprimierung",
    noFile: "Noch keine Dateien hinzugefügt",
    checkFile:
      "Die Konfigurationsdatei ist leer, bitte fügen Sie eine Datei hinzu",
    name: "Name",
    nameTip: "Die Eingabelänge beträgt 1-10 Stellen",
    checkName: "Der Name darf nicht leer sein, bitte erneut eingeben",
    checkName1: "Falsche Namenseingabe, bitte neu eingeben",
    room: "Geräte ID",
    roomTip:
      'Die Eingabelänge beträgt 1-24 Bit, und der Pegel wird durch "-" unterschieden',
    checkRoom: "Die Gerätenummer darf nicht leer sein, bitte erneut eingeben",
    checkRoom1: "Die Eingabe der Gerätenummer ist falsch, bitte neu eingeben",
    pic: "Bild",
    add: "Ergänzen",
    reset: "zurücksetzen",
    picTip: "Die maximale Upload-Größe einer Bilddatei beträgt 3m",
    checkPic: "Die Bilddatei darf nicht leer sein, bitte erneut auswählen",
    imgRegTip: "Nur Dateien in den Formaten jpg, jpeg, png hochladen",
    excRegTip: "Nur Dateien im xls- und xlsx-Format hochladen",
    zipRegTip: "Nur Dateien im ZIP-Format hochladen",
    produce: "Konfigurationsdatei generieren",
    confType: "Konfigurationstyp",
    pack: "Pack",
    batchAdd: "Batch hinzufügen",
    singleAdd: "Einfach hinzufügen",
    modelBatch: "Batch-Import-Vorlage herunterladen",
    uploadInfo: "Basisinformationen Excel hochladen",
    uploadPic: "Bildpaket-Zip hochladen",
    addName: "Fügen Sie ein einzelnes Datenelement hinzu",
    sameTip: "Seriennummer:",
    sameTip1: "Doppelte Gerätenummer",
    modelError:
      "Der Inhalt der hochgeladenen Grundinformationsdatei ist nicht korrekt, bitte ändern Sie die Datei gemäß der Vorlage",
    noPic:
      "Es gibt Daten in der Liste, die nicht mit Bildern hinzugefügt wurden, Sie müssen die Bilder vervollständigen, bevor Sie die Konfigurationsdatei erstellen",
    picBtnTip: "Bitte laden Sie zuerst die Grundinformationsdatei hoch",
    devType: "Ausstattungsart",
    devTypeTip: "Bitte wählen Sie einen Gerätetyp aus",
    checkDevType: "Der Gerätetyp darf nicht leer sein, bitte erneut wählen",
    indexName: "Seriennummer",
    IS: "Innengerät",
    GU: "Verwaltungsmaschine",
    OS1: "Sprachstation",
    OS2: "Wandmaschine",
    OS3: "Kleine Türstation",
    nameListTip:
      "In den hochgeladenen Basisdaten sind Daten mit einem unvollständigen Namensfeld, und die restlichen Daten wurden korrekt importiert",
    numListTip:
      "In den hochgeladenen Grunddaten sind im Feld Gerätenummer unvollständige Daten vorhanden, die restlichen Daten wurden korrekt importiert",
  },
  alarm: {
    ad: "AD-Zone",
    io: "IO-Zone",
    alarmPlus: "Zonenerweiterung",
    num: "Seriennummer",
    open: "offen",
    close: "schließen",
    machine: "Meldertyp",
    sendType: "Triggertyp",
    mode: "Modell",
    mType1: "Infrarot",
    mType2: "Tür magnetisch",
    mType3: "Fenstermagnet",
    mType4: "Gas",
    mType5: "Rauch",
    mType6: "Türklingel",
    mType7: "Newsletter-Button",
    mType8: "Infrarot-Türsensor",
    mType9: "Handalarm Türsensor",
    mType10: "Vibration",
    mType11: "Luftdruck",
    mType12: "andere",
    send1: "Sofort innerhalb von 24 Stunden melden",
    send2: "Verzögerter Alarm",
    send3: "Übertragungsverzögerung",
    send4: "Rufen Sie sofort die Polizei",
    send5: "Kreuzalarm",
    mode1: "Normalerweise offen",
    mode2: "Oft aus",
    presence: "zu Hause",
    leaving: "das Zuhause verlassen",
    timeSet: "Armbezogene Zeiteinstellung",
    delayTime: "Aktive Aktivierungsverzögerung (Sekunden)",
    startDelay: "Alarmauslöseverzögerung (Sekunden)",
    startUtil: "Alarmdauer(Minuten)",
    associated: "Zugehörige Zone",
  },
  house: {
    dev: "Ausrüstung",
    scene: "Szenen",
    vine: "Sensor",
    single: "Unabhängige Steuerung von Szenen",
    light: "Licht",
    air: "Klimaanlage",
    heat: "Fußbodenheizung",
    fresh: "Frischer Wind",
    switch: "Schaltsteckdose",
    curtain: "Vorhang",
    water: "Wasserkocher",
    bgm: "Hintergrundmusik",
    cust: "Benutzerdefiniertes Gerät",
    slight: "Licht",
    sAir: "Klimaanlage",
    sHeat: "Fußbodenheizung",
    sFresh: "Frischer Wind",
    sSwitch: "Schaltsteckdose",
    sCurtain: "Vorhang",
    sWater: "Wasserkocher",
    sBgm: "Hintergrundmusik",
    sCust: "Benutzerdefiniertes Gerät",
    IndependentControl: "Unabhängige Steuerung von Szenen",
    scene1: "Szene 1",
    scene2: "Szene 2",
    scene3: "Szene 3",
    scene4: "Szene 4",
    scene5: "Szene 5",
    scene6: "Szene 6",
    scene7: "Szene 7",
    scene8: "Szene 8",
    temp1: "Temperatur",
    temp2: "Feuchtigkeit",
    temp3: "Methan",
    temp4: "Biogas",
    picTip: "Es gibt keinen Grundriss",
    upload: "Grundriss hochladen",
    imgSize:
      "Die Bildgröße eines einzelnen Grundrisses darf 10M nicht überschreiten",
    imgName:
      "Der Name der hochgeladenen Grundrissdatei darf nicht auf Chinesisch erscheinen, bitte erneut auswählen",
    imgLength:
      "Die Gesamtzahl der hochgeladenen und hinzugefügten Grundrisse darf 8 nicht überschreiten, und die ersten 8 Bilder im Ordner wurden automatisch ausgewählt",
    imgCheckTip: "Der Grundriss passt nicht, bitte neu hochladen ",
    room1: "Haus Typ 1",
    room2: "Haus Typ 2",
    room3: "Haustyp 3",
    room4: "Haus Typ 4",
    room5: "Haus Typ 5",
    room6: "Haus Typ 6",
    room7: "Haustyp 7",
    room8: "Haustyp Figur 8",
    download: "Export",
    input: "Konfiguration importieren",
    title: "Geräteparametertabelle",
    name: "Name",
    location: "Standort",
    start: "Start-up",
    see: "sichtbar",
    noSee: "Unsichtbar",
    belong: "gehört",
    bgIcon: "Blaugraues Symbol",
    vineTip:
      "Bitte wählen Sie den Grundriss aus, bevor Sie die Temperiereigenschaften einstellen",
    sceneTip:
      "Bitte wählen Sie den Grundriss aus und stellen Sie dann die Szeneneigenschaften ein",
    dragTip:
      "Bitte wählen Sie den Grundriss aus, bevor Sie den Ziehvorgang durchführen",
    editTip: "Bearbeitet erfolgreich",
    addTip: "Beim Hochladen müssen Sie alle Grundrisse auf einmal auswählen",
    editError: "Bitte geben Sie den Bearbeitungsinhalt vor der Bearbeitung an",
    delError: "Bitte geben Sie vor dem Löschen den zu löschenden Inhalt an",
    delTip: "erfolgreich gelöscht",
    imgAddTip:
      "Die Gesamtzahl der hochgeladenen und hinzugefügten Grundrisse hat 8 erreicht und es können keine weiteren hinzugefügt werden",
    houseTitle: "Wechsel der Haustypkarte:",
    delHouseTip:
      "Dieser Vorgang löscht den Grundriss und die Konfigurationsinhalte. Möchten Sie fortfahren?",
    sendTip:
      "Importieren Sie den zu ändernden Konfigurationsinhalt erneut, Sie können die XML-Datei hochladen",
    checkType:
      "Das Format der hochgeladenen Datei ist falsch, bitte überprüfen Sie den Inhalt der Datei und laden Sie sie erneut hoch",
    importTip: "Konfigurationsdatei importieren",
    importTip1: "Importieren Sie den entsprechenden Grundriss",
    upLoadBtn: "Hochladen",
    picContent:
      "Die Reihenfolge beim Hochladen von Grundrissen muss mit der Reihenfolge der Grundrisse in der Konfigurationsdatei übereinstimmen",
    successFile: "Konfigurationsdatei erfolgreich hochgeladen",
    vineTipCheck:
      "Der Name darf nicht leer sein, bitte bestätigen Sie die Eingabe",
    picNumMax:
      "Bitte bestätigen Sie die Anzahl der importierten Bilder. Die aktuelle Anzahl der importierten Bilder ist größer als die Anzahl der Hauspläne in der Konfigurationsdatei. Bitte erneut auswählen",
    picNumMin:
      "Bitte bestätigen Sie die Anzahl der importierten Bilder. Die aktuelle Anzahl der importierten Bilder ist kleiner als die Anzahl der Hauspläne in der Konfigurationsdatei. Bitte wählen Sie erneut",
    maxSizeTip:
      "Die Anzahl oder Gesamtzahl der Hinzufügungen dieses Typs überschreitet das Limit. Wenn Sie etwas hinzufügen müssen, sortieren Sie bitte zuerst die hinzugefügten Geräte oder Szenen aus.",
    devNameTip: "Bitte geben Sie einen Namen ein",
    chromeTip: "Chrome-Browser wird empfohlen",
    downTip: "Klicken Sie hier,um zum Download - Link zu springen ",
    imgRegTip: "Nur Dateien im JPG- und JPEG-Format hochladen",
    threeTitle: "Drei-Konstanten-System",
    mainControl: "Meister",
    sedControl: "Untersteuerung",
    controlBtn: "Aufbau",
    configEdit: "Sanheng-Systemkonfigurationsdetails",
    moveTip:
      "Bitte ziehen Sie das Symbol in den Grundrissbereich, bitte ziehen Sie es erneut",
    repeatNameTip:
      "Grundrisse mit demselben Namen können nicht hochgeladen werden, bitte erneut auswählen",
    space: "(Reserviert)",
  },
  updateConfig: {
    tip0: "Wenn Sie den 24-Stunden-Alarm einstellen, stellen Sie den Schalter auf ON",
    tip1: "Beim Einstellen des 24-Stunden-Alarms sollte der Schalter auf Ein stehen",
    tip2: "Beim Einstellen eines sofortigen Alarms sollte der Schalter eingeschaltet sein",
    tip3: "Wenn der Verzögerungsalarm ausgeschaltet ist, muss die Lieferverzögerung ausgeschaltet werden",
    tip4: "Cross-Alarm wurde eingestellt, zugehörige Operation erforderlich",
    tip5: "Bitte schalten Sie zuerst den Verzögerungsalarm ein",
    tip6: "Wenn Sie den sofortigen Alarm einstellen, stellen Sie den Schalter auf Ein",
  },
  audio: {
    title: "Sprachhinweis Verpackungswerkzeug",
    lock: "Entsperrungston Hinweis",
    call: "Anrufhinweis",
    speak: "Gesprächshinweis",
    busy: "Beschäftigt Hinweis",
    tip1: "Klicken Sie zum Hochladen auf die .wav-Datei",
    tip2: "Dateigröße darf 1 MB nicht überschreiten",
    tip3: "Bitte laden Sie eine .wav-Datei hoch",
    tip4: "Bitte laden Sie alle Dateien hoch",
    add: "Dateien generieren",
  },
  threeProject: {
    hotWater: "Heizwassersystem",
    cho: "Formaldehyd",
    config: "Konfigurieren",
    unconfig: "Nicht konfigurieren",
  },
  elevator: {
    title: "Erzeugung der Aufzugssteuerungskonfiguration",
    label: "Aufzugssteuerungskonfigurationstabelle hochladen",
    uploadTip: "Zum Hochladen klicken oder Datei in diesen Bereich ziehen",
    upload: "Hochladen",
    download: "Vorlage herunterladen",
    downloadTip:
      "Klicken Sie hier, um die Vorlage für die Aufzugssteuerungskonfiguration herunterzuladen",
    error1:
      "[Physische Etage] ist fehlerhaft. Bitte überprüfen Sie die Konfigurationsdatei und importieren Sie sie erneut.",
    error2:
      "[Anzeigeetage] ist fehlerhaft. Bitte überprüfen Sie die Konfigurationsdatei und importieren Sie sie erneut.",
    error3:
      "[Adresse des Aufzugssteuerungsgateways] ist fehlerhaft. Bitte überprüfen Sie die Konfigurationsdatei und importieren Sie sie erneut.",
    error4:
      "[Anzeige der Aufzugsnummer] ist fehlerhaft. Bitte überprüfen Sie die Konfigurationsdatei und importieren Sie sie erneut.",
    error5:
      "[Geräte-IP] ist fehlerhaft. Bitte überprüfen Sie die Konfigurationsdatei und importieren Sie sie erneut.",
    error6:
      "[Aufzugssteuerungsgateway] Anzahl überschreitet das Limit. Bitte überprüfen Sie die Konfigurationsdatei und importieren Sie sie erneut.",
    generate: "Vorlage für die Aufzugssteuerungskonfiguration",
    fileLabel: "Aufzugssteuerungskonfigurationsdatei:",
    tip: "Bitte platzieren Sie die Konfigurationsdatei im PC-Tool unter [Ressourcenaktualisierung], um sie in das Gerät zu importieren.",
    downloadfile: "Herunterladen",
    fileName: "Aufzugssteuerungskonfiguration.xlsx",
    formatError:
      "Das Format der hochgeladenen Datei ist falsch. Bitte überprüfen Sie den Inhalt der Datei und laden Sie sie erneut hoch",
  },
};
